import { getUserLanguageFromAvailableLanguages } from '../localization/language-resolving';
import type { AppConfig, DataLayerBase, LanguageCode } from '../types';
import { createDataLayerBase } from './data-layer-base';
import { gtmSnippets } from './gtm-snippets';

function installTrackingScript(config: AppConfig) {
  const dataLayerBase = createDataLayerBase(config);

  const dataLayerScriptTag = document.createElement('script');
  dataLayerScriptTag.innerHTML = gtmSnippets.dataLayer(dataLayerBase);

  const installFunctionScriptTag = document.createElement('script');
  installFunctionScriptTag.innerHTML = gtmSnippets.installFunction(config.tracking.gtmId);

  const noScriptTag = document.createElement('noscript');
  noScriptTag.innerHTML = gtmSnippets.noScriptIframe(config.tracking.gtmId);

  document.head.prepend(dataLayerScriptTag);
  document.head.insertBefore(installFunctionScriptTag, dataLayerScriptTag.nextSibling);
  document.body.prepend(noScriptTag);
}

function changeTrackingLocale(locale: string): void {
  // First element is always the base config we need to modify
  (window.dataLayer[0] as DataLayerBase).pageLanguage = locale;
}

function setupLanguageChangeListeners(availableLanguages: Array<LanguageCode>) {
  window.addEventListener('languagechange', () => {
    changeTrackingLocale(getUserLanguageFromAvailableLanguages(availableLanguages));
  });

  window.addEventListener('languageChangeFromSettings', (e) => {
    const language = (e as CustomEvent).detail;
    changeTrackingLocale(language);
  });
}

export function setupTracking(config: AppConfig): void {
  installTrackingScript(config);
  setupLanguageChangeListeners(config.availableLanguages);
}
